import {Group, Switch, Text} from "@mantine/core";
import {useLocalStorage} from "@mantine/hooks";
import {LocalStorageKeys} from "../../../../types";
import classes from "./SettingSelectField.module.css";

export function DebugIndicatorToggle() {
    const [showIndicators, setShowIndicators] = useLocalStorage({
        key: LocalStorageKeys.ShowDebugIndicators,
        defaultValue: false,
    });

    return (
        <Group className={classes.outer}>
            <Text className={classes.innerItem}>Debug Indicators</Text>
            <Switch
                className={classes.innerItem}
                checked={showIndicators}
                onChange={(event) =>
                    setShowIndicators(event.currentTarget.checked)
                }
            />
        </Group>
    );
}
